import { ValidationStringMap } from '@bingads-webui/validation-string-map';
import type { StringDictionary } from '@bingads-webui/http-util';

type ValidationLegacyStringKey =
  | 'Validation_NotEmpty_Required_Field'
  | 'Validation_String_Max_Length'
  | 'Validation_String_Min_Length'
  | 'Validation_String_Invalid_Characters';

export type LegacyStrings = StringDictionary & Record<ValidationLegacyStringKey, string>;

// This File is to allow for support with the new TL syntax, please keep this up to date as keys.txt changes,
// or if we want to update the text on a string
// we have a tool will that builds a legacyi18nObject using this mapping
// the tool is buildLegacyI18n in @bingads-webui/build-legacy-i18n
// this file isn't exported, because we don't want the _TL_ syntax visible in the main exported code,
// as it breaks if not running through the bundler
export const legacyStrings: LegacyStrings = {
  ...ValidationStringMap,
  Validation_NotEmpty_Required_Field: _TL_('This field is required'),
  Validation_String_Max_Length: _TL_('Enter a value that is {{maxlength}} characters or less'),
  Validation_String_Min_Length: _TL_('Field should have more than {{minlength}} characters'),
  Validation_String_Invalid_Characters: _TL_('Enter a valid value'),
};
